module.exports = __webpack_public_path__ + "img/jg10.ac3b8f08.png";